export const uri = {
  test: "http://192.168.137.1:8180",
  dev: "http://127.0.0.1:8180",
  live: "https://api.rentage.app",
  mode: "live",
};
